import request from "./../utils/request";

export function getFilters(key) {
    return request.get(`/fav-filters/${key}`).then((res) => res.data);
}

export function createFilter(key, name, filters, user, payload, icon, visibility, position) {
    console.log("createFilter", {
        key,
        name,
        filters,
        user,
        payload,
        icon,
        visibility,
        position,
    });
    return request
        .post(`/fav-filters`, {
            name,
            key,
            icon,
            visibility,
            position,
            filters,
            user,
            payload,
        })
        .then((res) => res.data);
}

export function updateFilter(id, icon, name, filters, visibility) {
    return request.patch(`/fav-filters/${id}`, {
        icon,
        name,
        filters,
        visibility,
    });
}

export function updateFilterMultipleKey(id, updatingFields) {
    return request.patch(`/fav-filters/${id}/multiple`, { updatingFields }).then((res) => res.data);
}

export function deleteFilter(id) {
    return request.delete(`/fav-filters/${id}`);
}
